module.exports = __webpack_public_path__ + "static/media/place_door.7ea7ae43.png";